module.exports = __webpack_public_path__ + "img/overdue.2f4a7671.png";